import React, { useEffect } from "react"
import { useTranslation } from "next-i18next"
import { twMerge } from "tailwind-merge"
import clsx from "clsx"
import { GameStatusEnum, GameType } from "../../../services/games"
import { switchToChain } from "../../../utils/network"
import useBBBNetwork from "../../../hooks/useBBBNetwork"
import { getTitle1, getTitle2 } from "../../../utils/string"
import { ThumbDown } from "../../game/ThumbDown"
import { ThumbUp } from "../../game/ThumbUp"
import winImg from "../../../assets/imgs/icon/win.png"
import { LockSvg } from "../../../assets/svg"

export const GamePool = (props) => {
    const { t: tCommon } = useTranslation("common")

    const { currentChainId } = useBBBNetwork()

    const { game, onChangeGamePool } = props
    const { status, selections, chainId: gameChainId, type: gameType, result } = game

    const selection1 = selections[0]
    const selection2 = selections[1]

    const isEnd = [GameStatusEnum.RESULT_APPROVED].indexOf(status) >= 0

    const isLeftWin = isEnd && result === 1
    const isRightWin = isEnd && result === 2
    const isNoResult = !isLeftWin && !isRightWin && status !== GameStatusEnum.CREATE_REJECTED

    const isPrediction = gameType === GameType.PREDICTION
    const isInsurance = gameType === GameType.INSURANCE

    useEffect(() => {
        const checkNetwork = async () => {
            if (currentChainId > 0 && currentChainId !== gameChainId) {
                await switchToChain(gameChainId)

                return
            }
        }

        checkNetwork()
    }, [currentChainId])

    return (
        <div className={"fixed bottom-[74px] z-40 w-full border border-[#DFDDDE] bg-[#E8E8E8] lg:hidden"}>
            <div className={"b-flex-center h-[94px] gap-[9.5px]"}>
                <div
                    className={twMerge(
                        clsx(
                            "h-[66px] w-[154px] cursor-pointer rounded-[10px]  py-[11px] text-center text-white ",
                            isNoResult && isInsurance && "bg-[#CACBD6]",
                            isNoResult && isPrediction && "bg-[#AD5BB7]",
                            isNoResult && isPrediction && "hover-active:bg-[#AD5BB7]",
                            isLeftWin && "bg-[#FB5858]"
                        )
                    )}
                    onClick={() => onChangeGamePool(1)}
                >
                    <div className={"text-16 font-semibold leading-[19px]"}>{tCommon(getTitle1(gameType))}</div>
                    {isLeftWin ? (
                        <div
                            className={
                                "relative mx-auto mt-1 w-[45px] rounded-[5px] border-[0.5px] border-[#F5B826] bg-[#F4B821] pl-[16px] pr-[6px] text-12 font-semibold text-white"
                            }
                        >
                            <img src={winImg.src} className={"absolute top-[-6px] left-[-14px]"} />
                            {tCommon("win")}
                        </div>
                    ) : (
                        <>
                            {isInsurance ? (
                                <div className={"b-flex-center"}>
                                    <LockSvg width={15} height={21} />
                                </div>
                            ) : (
                                <ThumbUp
                                    gameType={gameType}
                                    name={selection1.name}
                                    className={"mx-auto mt-[7px]"}
                                    iconClassName={"grayscale group-hover:grayscale-0"}
                                />
                            )}
                        </>
                    )}
                </div>
                <div
                    className={twMerge(
                        clsx(
                            "group h-[66px] w-[154px] cursor-pointer rounded-[10px] bg-[#FB5858] py-[11px] text-center text-white",
                            isNoResult && isInsurance && "bg-[#AD5BB7]",
                            isNoResult && isPrediction && "hover-active:bg-[#FB5858]",
                            isRightWin && "bg-[#FB5858]"
                        )
                    )}
                    onClick={() => onChangeGamePool(2)}
                >
                    <div className={"text-16 font-semibold leading-[19px]"}>{tCommon(getTitle2(gameType))}</div>

                    {isRightWin ? (
                        <div
                            className={
                                "relative mx-auto mt-1 w-[45px] rounded-[5px] border-[0.5px] border-[#F5B826] bg-[#F4B821] pl-[16px] pr-[6px] text-12 font-semibold text-white"
                            }
                        >
                            <img src={winImg.src} className={"absolute top-[-6px] left-[-14px]"} />
                            {tCommon("win")}
                        </div>
                    ) : (
                        <>
                            {isPrediction && (
                                <ThumbDown
                                    gameType={gameType}
                                    name={selection2.name}
                                    className={"mx-auto mt-[7px]"}
                                    iconClassName={"grayscale group-hover:grayscale-0"}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}
